export default __webpack_public_path__ + "static/media/Project-1-PortfolioPage-MainImg.7e6b0525.png";